/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CustomQuestionnaireRadioAnswer
 */
export interface CustomQuestionnaireRadioAnswer {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireRadioAnswer
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireRadioAnswer
   */
  value: number;
}

/**
 * Check if a given object implements the CustomQuestionnaireRadioAnswer interface.
 */
export function instanceOfCustomQuestionnaireRadioAnswer(value: object): value is CustomQuestionnaireRadioAnswer {
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireRadioAnswerFromJSON(json: any): CustomQuestionnaireRadioAnswer {
  return CustomQuestionnaireRadioAnswerFromJSONTyped(json, false);
}

export function CustomQuestionnaireRadioAnswerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireRadioAnswer {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    value: json['value'],
  };
}

export function CustomQuestionnaireRadioAnswerToJSON(value?: CustomQuestionnaireRadioAnswer | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    value: value['value'],
  };
}
